import { inject, provide, type ComputedRef, type InjectionKey } from 'vue';
import type { SiteLocale } from '@/lib/site-locale';

export type SeoDetailLanguagePaths = Readonly<Partial<Record<SiteLocale, string>>>;

const SEO_DETAIL_LANGUAGE_PATHS_KEY: InjectionKey<ComputedRef<SeoDetailLanguagePaths>> = Symbol(
  'seo-detail-language-paths'
);

export function provideSeoDetailLanguagePaths(paths: ComputedRef<SeoDetailLanguagePaths>): void {
  provide(SEO_DETAIL_LANGUAGE_PATHS_KEY, paths);
}

export function useSeoDetailLanguagePaths(): ComputedRef<SeoDetailLanguagePaths> | null {
  return inject(SEO_DETAIL_LANGUAGE_PATHS_KEY, null);
}
